<template lang="html">
    <router-link v-if="$props.to" v-bind:to="$props.to" v-bind:class="classes">
        <z-icon v-bind:icon="$props.icon"></z-icon>
    </router-link>
    <div v-else v-bind:class="classes" v-on:click="onClick">
        <z-icon v-bind:icon="$props.icon"></z-icon>
    </div>
</template>
<script>
    import ZIcon from './ZIcon.vue';
    export default {
        name: 'z-icon-button',
        components: {ZIcon},
        props: {
            icon: {
                type: [String, Array, Object],
                default: () => [],
                required: true
            },
            to: {
                type: Object,
                default: null
            },
            rounded: {
                type: Boolean,
                default: false
            },
            success: {
                type: Boolean,
                default: false
            },
            primary: {
                type: Boolean,
                default: false
            },
            danger: {
                type: Boolean,
                default: false
            },
            successLight: {
                type: Boolean,
                default: false
            },
            primaryLight: {
                type: Boolean,
                default: false
            },
            dangerLight: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            classes() {
                return {
                    'z-icon-button': true,
                    'disabled': !!this.$props.disabled,
                    'rounded': !!this.$props.rounded,
                    'success': !!this.$props.success,
                    'primary': !!this.$props.primary,
                    'danger':  !!this.$props.danger,
                    'success-light': !!this.$props.successLight,
                    'primary-light': !!this.$props.primaryLight,
                    'danger-light':  !!this.$props.dangerLight
                };
            }
        },
        methods: {
            onClick(e) {
                if (this.$props.disabled) return;
                this.$emit('click', e);
            }
        }        
    }
</script>
<style lang="sass">
    .z-icon-button
        display: flex !important
        align-items: center
        justify-content: center
        width:  var(--a-icon-size-x45)
        height: var(--a-icon-size-x45)
        margin: var(--margin-x1)
        cursor: pointer
        border-radius: var(--bn)
        background: rgba(0, 0, 0, 0.1)
        transition: 0.2s ease !important
        background: var(--color-secondary-100)
        color: var(--color-secondary-900)
        flex-shrink: 0

        &.disabled
            opacity: 0.5
            cursor: not-allowed

        &:hover, &:active
            background: var(--color-secondary-200)

        .z-icon
            font-size: var(--a-icon-size-x3)
            line-height: var(--a-icon-size-x3)

        &.rounded
            border-radius: 100%

        &.success-light
            background: var(--color-success-100)
            .z-icon
                color: var(--color-success-900)
            &:hover, &:active
                background: var(--color-success-200)

        &.primary-light
            background: var(--color-primary-100)
            .z-icon
                color: var(--color-primary-900)
            &:hover, &:active
                background: var(--color-primary-200)

        &.danger-light
            background: var(--color-danger-100)
            .z-icon
                color: var(--color-danger-900)
            &:hover, &:active
                background: var(--color-danger-200)


        &.success
            background: var(--color-success-500)
            .z-icon
                color: var(--color-secondary-100)
            &:hover, &:active
                background: var(--color-success-800)

        &.primary
            background: var(--color-primary-500)
            .z-icon
                color: var(--color-secondary-100)
            &:hover, &:active
                background: var(--color-primary-800)

        &.danger
            background: var(--color-danger-500)
            .z-icon
                color: var(--color-secondary-100)
            &:hover, &:active
                background: var(--color-danger-800)                
</style>



// WEBPACK FOOTER //
// ZIconButton.vue?14ef1c4a